module.exports = __webpack_public_path__ + "img/blueSapphire@2x.fa55336.webp";